// extracted by mini-css-extract-plugin
export default {"root":"ZogBu","visible":"QLgP0"};